import React from "react";
import { Bath, Scissors, Sparkles, Heart, ArrowUpRight } from "lucide-react";
import Reveal from "../Reveal";
import { waLink } from "../../lib/site";

import banho from "../../assets/servicos/1.jpeg";

const services = [
  {
    icon: Bath,
    title: "Banho",
    desc: "Banho com produtos adequados, água em temperatura ideal e muito carinho.",
    featured: true,
    img: banho,
  },
  {
    icon: Scissors,
    title: "Tosa",
    desc: "Tosa na máquina, personalizada ou conforme a necessidade do pet.",
  },
  {
    icon: Sparkles,
    title: "Tosa Higiênica",
    desc: "Higienização das áreas íntimas, patinhas e região dos olhos.",
  },
  {
    icon: Heart,
    title: "Higienização",
    desc: "Limpeza de ouvidos, corte de unhas e cuidado com cada detalhe.",
  },
];

export default function Services() {
  return (
    <section
      id="servicos"
      data-testid="services-section"
      className="relative overflow-hidden py-24 sm:py-32 text-white bg-transparent"
    >
      <div className="container-pad relative z-10">
        <div className="max-w-3xl mb-14">
          <Reveal
            as="div"
            className="inline-block px-4 py-1.5 rounded-full bg-white/10 backdrop-blur-xl border border-white/15 text-white text-xs font-bold uppercase tracking-[0.18em] mb-5 shadow-sm"
          >
            Nossos serviços
          </Reveal>

          <Reveal
            as="h2"
            delay={80}
            className="font-heading text-3xl sm:text-4xl lg:text-5xl text-white tracking-tight leading-[1.1]"
          >
            Banho, tosa e higienização com{" "}
            <span className="italic text-gold">todo cuidado</span>.
          </Reveal>

          <Reveal
            as="p"
            delay={140}
            className="mt-5 text-base sm:text-lg text-white/72 leading-relaxed"
          >
            Serviços pensados para deixar seu pet limpo, confortável e bem cuidado.
          </Reveal>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
          <Reveal
            as="div"
            className="md:col-span-2 lg:row-span-2 relative rounded-[36px] overflow-hidden bg-royal text-white shadow-[0_35px_110px_rgba(0,0,0,0.35)] group hover:scale-[1.015] transition-all duration-700 border border-white/15"
          >
            <img
              src={services[0].img}
              alt={services[0].title}
              className="absolute inset-0 w-full h-full object-cover opacity-70 group-hover:opacity-80 group-hover:scale-105 transition-all duration-[1200ms]"
            />

            <div className="absolute inset-0 bg-gradient-to-br from-[#02112C] via-[#0A2558]/75 to-transparent" />
            <div className="absolute -top-24 -right-24 w-80 h-80 bg-gold/20 rounded-full blur-[90px] opacity-0 group-hover:opacity-100 transition-opacity duration-700" />

            <div className="relative p-8 sm:p-10 lg:p-12 min-h-[420px] flex flex-col justify-between">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-2xl bg-gold flex items-center justify-center text-royal shadow-[0_15px_40px_rgba(242,169,0,.35)]">
                  <Bath className="w-6 h-6" strokeWidth={2.2} />
                </div>
                <span className="text-xs uppercase tracking-[0.2em] font-bold text-gold">
                  Mais procurado
                </span>
              </div>

              <div>
                <h3 className="font-heading text-3xl sm:text-4xl font-semibold mb-3 text-white">
                  Banho &amp; Bem-estar
                </h3>
                <p className="text-white/85 max-w-md leading-relaxed">
                  Do shampoo ao secador, cada etapa é feita com carinho para o conforto do seu pet.
                </p>

                <a
                  href={waLink("Olá! Gostaria de agendar um banho para o meu pet.")}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-2 mt-6 bg-gold hover:bg-gold-hover text-royal font-semibold rounded-full px-5 py-3 transition-all hover:-translate-y-1 shadow-[0_15px_40px_rgba(242,169,0,.45)]"
                >
                  Agendar agora
                  <ArrowUpRight className="w-4 h-4" />
                </a>
              </div>
            </div>
          </Reveal>

          {services.slice(1).map((s, i) => (
            <Reveal
              key={s.title}
              delay={120 + i * 70}
              as="div"
              className="group relative overflow-hidden rounded-[30px] p-7 bg-white/10 backdrop-blur-xl border border-white/15 shadow-[0_25px_80px_rgba(0,0,0,0.22)] hover:bg-white/16 hover:shadow-[0_35px_100px_rgba(0,0,0,0.30)] hover:-translate-y-1 transition-all"
            >
              <div className="absolute -top-20 -right-20 w-44 h-44 bg-gold/15 rounded-full blur-3xl opacity-0 group-hover:opacity-100 transition-opacity" />

              <div className="relative w-12 h-12 rounded-2xl bg-gold text-royal flex items-center justify-center mb-5 group-hover:scale-110 group-hover:rotate-[-6deg] transition-all shadow-[0_15px_40px_rgba(242,169,0,.28)]">
                <s.icon className="w-6 h-6" strokeWidth={2.2} />
              </div>

              <h3 className="relative font-heading text-xl font-semibold text-white mb-1.5">
                {s.title}
              </h3>

              <p className="relative text-sm text-white/70 leading-relaxed">
                {s.desc}
              </p>

              <ArrowUpRight className="w-5 h-5 text-white/30 absolute top-6 right-6 group-hover:text-gold group-hover:rotate-45 transition-all" />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
